import { useState } from "react";

// モーダル表示などの際に、背景のスクロールを禁止する
export const useFixBackground = () => {
  const [bodyPosition, setBodyPosition] = useState(0);

  const fixBody = () => {
    const currentPosition = document.documentElement.scrollTop || document.body.scrollTop;
    setBodyPosition(currentPosition);
    document.body.style.position = "fixed";
    document.body.style.width = "100%";
    document.body.style.top = `-${currentPosition}px`;
  };

  const unFixBody = () => {
    document.body.style.position = "";
    document.body.style.width = "";
    document.body.style.top = "";
    window.scrollTo(0, bodyPosition);
  };

  return { fixBody, unFixBody };
};
